export enum GroupsEnum {
  CONCILIACAO = "CONCILIACAO",
  FISCAL = "FISCAL",
  FINANCEIRO = "FINANCEIRO",
  TI = "TI",
  RETAGUARDA_DE_LOJA = "RETAGUARDA_DE_LOJA",
  OPERACIONAL = "OPERACIONAL",
  CRM = "CRM",
  ADM = "ADM",
  PLANEJAMENTO_COMERCIAL = "PLANEJAMENTO_COMERCIAL",
  RECURSOS_HUMANOS = "RECURSOS_HUMANOS",
  ETIQUETA_REMARCADOS = "ETIQUETA_REMARCADOS",
  REMARCACAO_DE_PRECO = "REMARCACAO_DE_PRECO",
}
